import { render, staticRenderFns } from "./Date.vue?vue&type=template&id=6ddade6d&"
import script from "./Date.vue?vue&type=script&lang=js&"
export * from "./Date.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/dev/tafelgasten.outlawz.dev/web/app/themes/expert/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ddade6d')) {
      api.createRecord('6ddade6d', component.options)
    } else {
      api.reload('6ddade6d', component.options)
    }
    module.hot.accept("./Date.vue?vue&type=template&id=6ddade6d&", function () {
      api.rerender('6ddade6d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/vue/Agenda/Date.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/Agenda/Date.vue
// module id = 412
// module chunks = 0